
import { defineComponent } from 'vue';
import PrologueTemplate from '@/components/templates/prologue/PrologueTemplate.vue';

export default defineComponent({
  name: 'Prologue',
  components: { PrologueTemplate },
});
